import React from 'react';
import { connect } from "react-redux";
import './PositionName.css';
import { Typography } from "@mui/material";

class PositionName extends React.Component {

    render() {
        return (
        <div id='position_name'>
            <Typography>
                {"Position: " + this.props.tourName}
            </Typography>
        </div>
        )
    }
    
}

const mapStateToProps = state => ({
    ...state,
});

export default connect(mapStateToProps)(PositionName);
